// Bilingual dictionary. Proper nouns (program codes, people's names, club names)
// stay in English in both languages for consistency.

export const TRANSLATIONS = {
  en: {
    "nav.admissionsOpen": "Admissions Open · 2026",
    "nav.programs": "Programs",
    "nav.achievements": "Achievements",
    "nav.contact": "Contact",
    "nav.call": "Call",

    "btn.callNow": "Call Now",
    "btn.download": "Download Brochure",
    "btn.whatsapp": "WhatsApp",
    "btn.explore": "Explore Programs",
    "btn.talkAdmissions": "Talk to Admissions",

    "hero.est": "Est. 2006 · Kerala, India",
    "hero.officialBrochure": "Official · Brochure",
    "hero.location": "Kottappady · Kerala",
    "hero.description":
      "Where AI, Robotics & Human Values converge. A new generation of Honours programs — engineered for the careers of tomorrow, infused with the timeless wisdom of holistic development.",
    "hero.affiliated": "Affiliated to M.G. University",
    "hero.approved": "Approved by Govt. of Kerala",
    "hero.naac": "NAAC Accredited · B++",
    "hero.systemOnline": "System Online",
    "hero.programs": "Programs",
    "hero.specializations": "Specializations",
    "hero.aiIntegrated": "AI-Integrated",
    "hero.streams": "Streams",
    "hero.established": "Established",
    "hero.naacGrade": "NAAC Grade",
    "hero.enrollmentWindow": "Enrollment Window",
    "hero.minorityTag": "Christian Minority Arts & Science · Self-Financing",

    "about.kicker": "About // The Institution",
    "about.headlineA": "Engineering tomorrow's",
    "about.headlineB": "leaders",
    "about.headlineC": "today.",
    "about.body":
      "Established in 2006 as a Christian Minority Arts & Science College, Mar Elias transforms lives and communities through holistic development and socio-economic freedom — by imparting higher education infused with human values, ethical thinking and gender neutrality.",
    "about.vision": "Vision",
    "about.visionBody":
      "Transforming lives and communities through holistic development and socio-economic freedom, infused with human values.",
    "about.mission": "Mission",
    "about.missionBody":
      "Equip students with the skills required to seize opportunities and meet the challenges of an ever-changing society.",
    "about.years": "Years of Legacy",
    "about.ug": "UG Honours",
    "about.pg": "PG Streams",
    "about.campusBadge": "Kottappady Campus",

    "ug.kicker": "Programs // Undergraduate",
    "ug.headA": "5 Honours degrees.",
    "ug.headB": "19 future-ready",
    "ug.headC": "specializations.",
    "ug.sub":
      "Every UG programme is delivered as an Honours degree with embedded specializations across AI, Robotics, Cybersecurity, ACCA, Aviation and beyond.",
    "ug.specializations": "Specializations",

    "pg.kicker": "Programs // Postgraduate",
    "pg.head": "Advance further. Specialise deeper.",

    "ach.kicker": "Signal // Achievements",
    "ach.headA": "Proof in",
    "ach.headB": "performance",
    "ach.headC": ".",
    "ach.sub":
      "Our students consistently break records — at the university, state and national levels.",
    "ach.cmScholarship": "Chief Minister's Merit Scholarship",
    "ach.awarded": "Awarded 2023-24",
    "ach.stateAward": "State-Level Award",
    "ach.rankHolders": "MG University · Rank Holders 2025",
    "ach.sports": "State-Level Sports",
    "ach.champions": "Champions",
    "ach.kalolsavam": "Kalolsavam · A Grade",
    "ach.tagline": "Where talent meets transformation.",
    "ach.taglineSub":
      "Scholarships, mentorship and infrastructure to help every student rise.",
    "ach.taglineMicro": "· Excellence is engineered ·",

    "gallery.kicker": "Live Feed // Campus Moments",
    "gallery.headA": "Glimpses from",
    "gallery.headB": "our campus",
    "gallery.hint": "Tap any frame to expand · ESC / ← → to navigate",
    "gallery.snapshots": "Snapshots · Live",

    "campus.kicker": "Operating System // Campus Life",
    "campus.headA": "A campus built for",
    "campus.headB": "deep work",
    "campus.and": "and",
    "campus.headC": "bold play",
    "campus.clubsLabel": "Clubs & Associations · 14 active",
    "campus.cellsKicker": "Cells & Committees",
    "campus.cellsHead":
      "Frameworks that keep our campus safe, ethical and ambitious.",

    "why.kicker": "Why // Mar Elias",
    "why.headA": "Six reasons it's the",
    "why.headB": "smartest choice",
    "why.headC": "you'll make.",

    "footer.kicker": "Ready · To · Begin",
    "footer.headA": "Your future is",
    "footer.headB": "one call",
    "footer.headC": "away.",
    "footer.sub":
      "Admissions for 2026 are open. Speak directly to our admissions team.",
    "footer.address": "Address",
    "footer.callLbl": "Call",
    "footer.reach": "Reach Online",
    "footer.tagline":
      "Transforming lives and communities through holistic development and socio-economic freedom. Affiliated to M.G. University, Approved by Govt. of Kerala, NAAC B++.",
    "footer.copy": "MAR ELIAS COLLEGE · ALL RIGHTS RESERVED",
    "footer.online": "System · Online",
  },
  ml: {
    "nav.admissionsOpen": "പ്രവേശനം ആരംഭിച്ചു · 2026",
    "nav.programs": "കോഴ്സുകൾ",
    "nav.achievements": "നേട്ടങ്ങൾ",
    "nav.contact": "ബന്ധപ്പെടുക",
    "nav.call": "വിളിക്കുക",

    "btn.callNow": "ഇപ്പോൾ വിളിക്കുക",
    "btn.download": "ബ്രോഷർ ഡൗൺലോഡ്",
    "btn.whatsapp": "വാട്സ്ആപ്പ്",
    "btn.explore": "കോഴ്സുകൾ കാണുക",
    "btn.talkAdmissions": "അഡ്മിഷൻസുമായി സംസാരിക്കുക",

    "hero.est": "സ്ഥാപിതം 2006 · കേരളം, ഇന്ത്യ",
    "hero.officialBrochure": "ഔദ്യോഗിക · ബ്രോഷർ",
    "hero.location": "കോട്ടപ്പടി · കേരളം",
    "hero.description":
      "AI, റോബോട്ടിക്സ്, മാനവിക മൂല്യങ്ങൾ ഒത്തുചേരുന്നിടം. നാളെയുടെ കരിയറുകൾക്കായി രൂപകൽപ്പന ചെയ്ത, സമഗ്രമായ വളർച്ചയ്ക്കായി ഉൾപ്പെടുത്തിയ പുതുതലമുറയിലെ ഓണേഴ്സ് കോഴ്സുകൾ.",
    "hero.affiliated": "എം.ജി. യൂണിവേഴ്സിറ്റിയിൽ അഫിലിയേറ്റ് ചെയ്തത്",
    "hero.approved": "കേരള സർക്കാർ അംഗീകൃതം",
    "hero.naac": "NAAC അക്രഡിറ്റേഷൻ · B++",
    "hero.systemOnline": "സിസ്റ്റം ഓൺലൈൻ",
    "hero.programs": "കോഴ്സുകൾ",
    "hero.specializations": "സ്പെഷ്യലൈസേഷനുകൾ",
    "hero.aiIntegrated": "AI ഉൾപ്പെടുത്തിയത്",
    "hero.streams": "സ്ട്രീമുകൾ",
    "hero.established": "സ്ഥാപിതം",
    "hero.naacGrade": "NAAC ഗ്രേഡ്",
    "hero.enrollmentWindow": "എൻറോൾമെൻ്റ് വിൻഡോ",
    "hero.minorityTag":
      "ക്രിസ്ത്യൻ മൈനോറിറ്റി ആർട്സ് & സയൻസ് · സെൽഫ്-ഫിനാൻസിങ്",

    "about.kicker": "ഞങ്ങളെക്കുറിച്ച് // സ്ഥാപനം",
    "about.headlineA": "നാളെയുടെ",
    "about.headlineB": "നേതാക്കളെ",
    "about.headlineC": "ഇന്നു തന്നെ.",
    "about.body":
      "2006-ൽ ഒരു ക്രിസ്ത്യൻ മൈനോറിറ്റി ആർട്സ് & സയൻസ് കോളേജായി സ്ഥാപിതമായ Mar Elias, മാനവിക മൂല്യങ്ങളും ധാർമിക ചിന്തയും ലിംഗ സമത്വവും ഉൾപ്പെടുത്തിയ ഉന്നത വിദ്യാഭ്യാസത്തിലൂടെ ജീവിതങ്ങളെയും സമൂഹങ്ങളെയും രൂപാന്തരപ്പെടുത്തുന്നു.",
    "about.vision": "ദർശനം",
    "about.visionBody":
      "മാനവിക മൂല്യങ്ങൾ ഉൾപ്പെടുത്തിയ ഉന്നത വിദ്യാഭ്യാസത്തിലൂടെ ജീവിതങ്ങളെയും സമൂഹങ്ങളെയും രൂപാന്തരപ്പെടുത്തുക.",
    "about.mission": "ദൗത്യം",
    "about.missionBody":
      "നിത്യം മാറുന്ന സമൂഹത്തിലെ അവസരങ്ങൾ ഉപയോഗപ്പെടുത്താനും വെല്ലുവിളികൾ നേരിടാനും ആവശ്യമായ കഴിവുകൾ വിദ്യാർത്ഥികളിൽ വളർത്തുക.",
    "about.years": "വർഷങ്ങളുടെ പാരമ്പര്യം",
    "about.ug": "UG ഓണേഴ്സ്",
    "about.pg": "PG സ്ട്രീമുകൾ",
    "about.campusBadge": "കോട്ടപ്പടി കാമ്പസ്",

    "ug.kicker": "കോഴ്സുകൾ // ബിരുദം",
    "ug.headA": "5 ഓണേഴ്സ് ബിരുദങ്ങൾ.",
    "ug.headB": "19 ഭാവിയിലേക്കുള്ള",
    "ug.headC": "സ്പെഷ്യലൈസേഷനുകൾ.",
    "ug.sub":
      "ഓരോ UG കോഴ്സും AI, റോബോട്ടിക്സ്, സൈബർസെക്യൂരിറ്റി, ACCA, ഏവിയേഷൻ തുടങ്ങിയ സ്പെഷ്യലൈസേഷനുകൾ ഉൾപ്പെടുത്തിയ ഓണേഴ്സ് ബിരുദമായാണ് നൽകുന്നത്.",
    "ug.specializations": "സ്പെഷ്യലൈസേഷനുകൾ",

    "pg.kicker": "കോഴ്സുകൾ // ബിരുദാനന്തരം",
    "pg.head": "കൂടുതൽ മുന്നോട്ടു പോകുക. ആഴത്തിൽ പഠിക്കുക.",

    "ach.kicker": "സിഗ്നൽ // നേട്ടങ്ങൾ",
    "ach.headA": "പ്രകടനത്തിലെ",
    "ach.headB": "തെളിവ്",
    "ach.headC": ".",
    "ach.sub":
      "യൂണിവേഴ്സിറ്റി, സംസ്ഥാന, ദേശീയ തലങ്ങളിൽ ഞങ്ങളുടെ വിദ്യാർത്ഥികൾ തുടർച്ചയായി റെക്കോർഡുകൾ ഭേദിക്കുന്നു.",
    "ach.cmScholarship": "മുഖ്യമന്ത്രിയുടെ മെറിറ്റ് സ്കോളർഷിപ്പ്",
    "ach.awarded": "2023-24 ൽ നൽകി",
    "ach.stateAward": "സംസ്ഥാന തല പുരസ്കാരം",
    "ach.rankHolders": "MG യൂണിവേഴ്സിറ്റി · റാങ്ക് ഹോൾഡേഴ്സ് 2025",
    "ach.sports": "സംസ്ഥാന തല കായികം",
    "ach.champions": "ചാമ്പ്യന്മാർ",
    "ach.kalolsavam": "കലോത്സവം · A ഗ്രേഡ്",
    "ach.tagline": "കഴിവ് രൂപാന്തരപ്പെടുന്നിടം.",
    "ach.taglineSub":
      "ഓരോ വിദ്യാർത്ഥിയും ഉയരാൻ വേണ്ടി സ്കോളർഷിപ്പുകൾ, മാർഗനിർദേശം, അടിസ്ഥാന സൗകര്യങ്ങൾ.",
    "ach.taglineMicro": "· മികവ് രൂപകൽപ്പന ചെയ്തത് ·",

    "gallery.kicker": "ലൈവ് ഫീഡ് // കാമ്പസ് നിമിഷങ്ങൾ",
    "gallery.headA": "ഞങ്ങളുടെ കാമ്പസിലെ",
    "gallery.headB": "നിമിഷങ്ങൾ",
    "gallery.hint": "വലുതാക്കാൻ ഏതെങ്കിലും ഫ്രെയിം ടാപ്പ് ചെയ്യുക · ESC / ← → നാവിഗേറ്റ്",
    "gallery.snapshots": "സ്നാപ്പ്ഷോട്ടുകൾ · ലൈവ്",

    "campus.kicker": "ഓപ്പറേറ്റിങ്ങ് സിസ്റ്റം // കാമ്പസ് ജീവിതം",
    "campus.headA": "ആഴത്തിലുള്ള",
    "campus.headB": "പഠനത്തിനും",
    "campus.and": "ധൈര്യമേറിയ",
    "campus.headC": "കളിക്കും",
    "campus.clubsLabel": "ക്ലബ്ബുകൾ & അസോസിയേഷനുകൾ · 14 സജീവം",
    "campus.cellsKicker": "സെല്ലുകൾ & കമ്മിറ്റികൾ",
    "campus.cellsHead":
      "നമ്മുടെ കാമ്പസ് സുരക്ഷിതവും ധാർമികവും അഭിലാഷപൂർണ്ണവുമായി നിലനിർത്തുന്ന ചട്ടക്കൂടുകൾ.",

    "why.kicker": "എന്തുകൊണ്ട് // Mar Elias",
    "why.headA": "നിങ്ങൾ എടുക്കുന്ന ഏറ്റവും",
    "why.headB": "മികച്ച തിരഞ്ഞെടുപ്പിന്",
    "why.headC": "ആറ് കാരണങ്ങൾ.",

    "footer.kicker": "ആരംഭിക്കാൻ · തയ്യാർ",
    "footer.headA": "നിങ്ങളുടെ ഭാവി",
    "footer.headB": "ഒരു വിളിയിൽ",
    "footer.headC": "നിന്ന്.",
    "footer.sub":
      "2026 പ്രവേശനം ആരംഭിച്ചു. ഞങ്ങളുടെ അഡ്മിഷൻസ് ടീമുമായി നേരിട്ട് സംസാരിക്കുക.",
    "footer.address": "വിലാസം",
    "footer.callLbl": "വിളിക്കാൻ",
    "footer.reach": "ഓൺലൈൻ ബന്ധം",
    "footer.tagline":
      "സമഗ്രമായ വളർച്ചയിലൂടെയും സാമൂഹിക-സാമ്പത്തിക സ്വാതന്ത്ര്യത്തിലൂടെയും ജീവിതങ്ങളെ രൂപാന്തരപ്പെടുത്തുന്നു. എം.ജി. യൂണിവേഴ്സിറ്റി അഫിലിയേറ്റഡ്, കേരള സർക്കാർ അംഗീകൃതം, NAAC B++.",
    "footer.copy": "MAR ELIAS COLLEGE · എല്ലാ അവകാശങ്ങളും സംരക്ഷിച്ചിരിക്കുന്നു",
    "footer.online": "സിസ്റ്റം · ഓൺലൈൻ",
  },
};

// Why-us items (translated separately because of list structure)
export const WHY_US_T = {
  en: [
    {
      title: "Industry-Aligned Curriculum",
      desc: "AI, Robotics, Cybersecurity & Data Science integrated into honours programs — graduates job-ready for the next decade.",
    },
    {
      title: "Merit Scholarships",
      desc: "Attractive scholarships for excellence in Academics, Arts and Sports including state-recognised merit awards.",
    },
    {
      title: "Advanced Infrastructure",
      desc: "A/C smart classrooms, computer labs, seminar halls and auditorium — built for modern learning.",
    },
    {
      title: "Holistic Development",
      desc: "Curricular, co-curricular and extra-curricular activities aligned with human values & ethical thinking.",
    },
    {
      title: "Strong Industry Tie-ups",
      desc: "ICSI approved study centre · ACCA exemptions · Placement & Career Guidance Cell.",
    },
    {
      title: "Vibrant Campus Life",
      desc: "14 clubs, 10 cells & committees, NCC, NSS, Campus Radio and state-level sports recognition.",
    },
  ],
  ml: [
    {
      title: "ഇൻഡസ്ട്രി അനുയോജ്യ പാഠ്യപദ്ധതി",
      desc: "AI, റോബോട്ടിക്സ്, സൈബർസെക്യൂരിറ്റി, ഡാറ്റാ സയൻസ് — അടുത്ത ദശാബ്ദത്തിലെ ജോലികൾക്കായി തയ്യാറായ ഓണേഴ്സ് ബിരുദധാരികൾ.",
    },
    {
      title: "മെറിറ്റ് സ്കോളർഷിപ്പുകൾ",
      desc: "അക്കാദമിക്, കല, കായികം എന്നിവയിലെ മികവിന് ആകർഷകമായ സ്കോളർഷിപ്പുകൾ — സംസ്ഥാന അംഗീകൃത പുരസ്കാരങ്ങൾ ഉൾപ്പെടെ.",
    },
    {
      title: "ആധുനിക അടിസ്ഥാന സൗകര്യങ്ങൾ",
      desc: "A/C സ്മാർട്ട് ക്ലാസ്റൂമുകൾ, കമ്പ്യൂട്ടർ ലാബുകൾ, സെമിനാർ ഹാളുകൾ — ആധുനിക പഠനത്തിന് വേണ്ടി രൂപകൽപ്പന ചെയ്തത്.",
    },
    {
      title: "സമഗ്ര വളർച്ച",
      desc: "മാനവിക മൂല്യങ്ങളും ധാർമിക ചിന്തയും ഉൾപ്പെടുത്തിയ പാഠ്യ-സഹപാഠ്യ-പാഠ്യേതര പ്രവർത്തനങ്ങൾ.",
    },
    {
      title: "ഇൻഡസ്ട്രി പങ്കാളിത്തം",
      desc: "ICSI അംഗീകൃത സ്റ്റഡി സെൻ്റർ · ACCA ഇളവുകൾ · പ്ലേസ്മെൻ്റ് സെൽ.",
    },
    {
      title: "ഊർജസ്വലമായ കാമ്പസ് ജീവിതം",
      desc: "14 ക്ലബ്ബുകൾ, 10 സെല്ലുകൾ & കമ്മിറ്റികൾ, NCC, NSS, കാമ്പസ് റേഡിയോ, സംസ്ഥാന തല കായിക അംഗീകാരം.",
    },
  ],
};

// Facility labels translation map
export const FACILITY_LABELS = {
  en: {
    "ICT Classrooms": "ICT Classrooms",
    "Central Library": "Central Library",
    "A/C Computer Lab": "A/C Computer Lab",
    "A/C Seminar Hall": "A/C Seminar Hall",
    "A/C Auditorium": "A/C Auditorium",
    Canteen: "Canteen",
    "College Bus": "College Bus",
    Playground: "Playground",
    "Hostel Facility": "Hostel Facility",
  },
  ml: {
    "ICT Classrooms": "ICT ക്ലാസ്റൂമുകൾ",
    "Central Library": "സെൻട്രൽ ലൈബ്രറി",
    "A/C Computer Lab": "A/C കമ്പ്യൂട്ടർ ലാബ്",
    "A/C Seminar Hall": "A/C സെമിനാർ ഹാൾ",
    "A/C Auditorium": "A/C ഓഡിറ്റോറിയം",
    Canteen: "കാൻ്റീൻ",
    "College Bus": "കോളേജ് ബസ്",
    Playground: "പ്ലേഗ്രൗണ്ട്",
    "Hostel Facility": "ഹോസ്റ്റൽ സൗകര്യം",
  },
};
